import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const MusicSupervision = () => {
  const navigate = useNavigate();

  return (
    <div
      className="music-supervision"
      style={{ background: "#000", paddingBlock: "50px" }}
    >
      <Container className="content-section d-flex align-items-center">
        <Row>
          <Col md={6}>
            <Image
              alt="Spotify curator image"
              className="spotify-curator-image"
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"
              fluid
            />
          </Col>
          <Col md={6}>
            <Image
              className="mb-4"
              alt="Search icon graphic"
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"
              fluid
            />
            <h3 className="font-weight-light text-white">
              Additional <mark>Music Services</mark>
            </h3>
            <Image
              alt="Small blue and purple gradient divider"
              className="gradient-divider"
              src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"
              fluid
            />
            <p style={{ color: "#fff" }}>
              If you're in need of more guidance with your project, Music
              Gateway represents a network of UK and US music supervisors able
              to assist with creative direction. A range of composers are also
              available for hire to create bespoke compositions.
            </p>
              <Button
                variant="outline-light"
                className="gradient_border_btn"
                onClick={() =>
                  window.open(
                    "https://dashboard.fttunes.com/register.php",
                    // "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                Music supervision
              </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MusicSupervision;
